export default __webpack_public_path__ + "static/Economic Model Whitepaper - Italian-972bf22a66db68c6dd715c7c59c1daae.pdf";